export enum WorkspaceDomainCertStatus {
  Pending = 'pending',
  Success = 'success',
  Retrying = 'retrying',
  Failed = 'failed',
}

export interface WorkspaceDomain {
  cert_status: WorkspaceDomainCertStatus | null
  cname: string | null
  id: number
  name: string
  subdomain: boolean
}

export const isCertified = (wsd: WorkspaceDomain | null) => {
  return !wsd || wsd.subdomain || wsd.cert_status === WorkspaceDomainCertStatus.Success
}

export const isPendingOrRetrying = (wsd: WorkspaceDomain | null) => {
  return isPending(wsd) || isRetrying(wsd)
}

export const isPending = (wsd: WorkspaceDomain | null) => {
  return wsd && !wsd.subdomain && wsd.cert_status === WorkspaceDomainCertStatus.Pending
}

export const isRetrying = (wsd: WorkspaceDomain | null) => {
  return wsd && !wsd.subdomain && wsd.cert_status === WorkspaceDomainCertStatus.Retrying
}

export const isFailed = (wsd: WorkspaceDomain) => {
  return !wsd.subdomain && wsd.cert_status === WorkspaceDomainCertStatus.Failed
}

export type WorkspaceDomainAttributes = Omit<WorkspaceDomain, 'cert_status' | 'cname' | 'id'>
